import React, { useEffect, useState } from "react";
import { AdminService } from "../../../services";
import _ from "lodash";
import { renderTypeIdentificationDescription } from "../../../utils/utils";
import { GreenCheck } from "../../../assets/icons/component";
import { tipoActividad } from "../../../__mocks__/data";

interface Box2JuridicaProps {
  personaJuridica: any;
  repLegal: any;
  changeDatoList: any
}

export const Box2Juridica = ({ personaJuridica, repLegal, changeDatoList }: Box2JuridicaProps) => {
  const [update, setUpdate] = useState(false);
  const [allCities, setAllCities] = useState<any>(null);
  const [revisado, setRevisado] = useState(true);

  const handleEdit = () => {
    setUpdate(!update);
  };

  useEffect(() => {
    // Cargar ciudades
    AdminService.getAllCiudades().then((Datos: any) => {
      if (parseInt(Datos.payload.data.ListCiudad.Datos_Ciudad[0].s_codigo) > 0) {
        setAllCities(Datos.payload.data);
      }
    });

    
  }, []);

   // Función para formatear fechas
  const formatDate = (dateString: string) => {
    if (!dateString) return "N/A";
    
    const parts = dateString.split('-');
    if (parts.length >= 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateString;
  };

   // Obtener nombre de ciudad
  const getCityName = (code: string) => {
    if (!code || !allCities) return "N/A";
    
    const city = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_codigo: code });
    return city.length > 0 ? city[0].s_nombre : code;
  };

    const getActivityName = (code: string) => {
   // if (!code || !tipoActividad) return "N/A";
    console.log(code)
  const activity = _.filter(
  tipoActividad.WS_TIPOS_ACT_ECONOMICA_IResult.listActEcon.Datos_ActividadEcon,
    (item) => item?.s_codigo?.toString() == code?.toString()
  );
    console.log(activity)
    return activity.length > 0 ? activity[0].s_descripcion : 'Desconocida';
  };

  return (
    <div className="box">
      <ul className="title">
        <li>2.</li>
        <li>Información Personal</li>
        {!update && (
          <div onClick={handleEdit}>
            <span className="icon-edit" /> {/* Usa tu icono de edición aquí */}
          </div>
        )}
      </ul>
      <div className="sub-box redBox">
        <ul className="nopadding">
          <li>
            <label>Nombre sociedad</label>
            <p>{personaJuridica?.nom_socie}</p>
          </li>
          <li>
            <label>Número de identificación</label>
            <p>{personaJuridica?.Identificacion}</p>
          </li>
          <li>
            <label>Tipo Identificación</label>
            <p>{renderTypeIdentificationDescription(personaJuridica?.tipo_identificacion)}</p>
          </li>
          <li>
            <label>Fecha de creación</label>
            <p>{formatDate(personaJuridica?.fec_crea)}</p>
          </li>
          <li>
            <label>Código CIIU</label>
            <p>{personaJuridica?.cod_ciu}</p>
          </li>
           <li>
            <label>Actividad económica</label>
            <p>{getActivityName(personaJuridica?.cod_ciu) || "N/A"}</p>
          </li>
         
        </ul>
        <ul className="nopadding">
        
          <li>
            <label>Tipo de empresa</label>
            <p>{personaJuridica?.tip_emp || "N/A"}</p>
          </li>
          <li>
            <label>Dirección</label>
            <p>{personaJuridica?.Direccion || "N/A"}</p>
          </li>
         {/*  <li>
            <label>Teléfono secundario</label>
            <p>{repLegal?.Pws_Telefono2 || "N/A"}</p>
          </li> */}
          <li>
            <label>Ciudad</label>
            <p>{personaJuridica?.Ciudad_residencia || "N/A"}</p>
          </li>
        </ul>
      </div>
      <div className="sub-box redBox">
        <h3>Representante legal</h3>
        <ul className="nopadding">
          <li>
            <label>Nombres</label>
            <p>{repLegal?.Pws_Nombres}</p>
          </li>
          <li>
            <label>Apellidos</label>
            <p>{`${repLegal?.Pws_Apellidos1} ${repLegal?.Pws_Apellidos2 || ""}`}</p>
          </li>
          <li>
            <label>Tipo Identificación</label>
            <p>{renderTypeIdentificationDescription(repLegal?.Pws_Tip_Identificacion)}</p>
          </li>
          <li>
            <label>Número de identificación</label>
            <p>{repLegal?.Pws_Identificacion}</p>
          </li>
          <li>
            <label>Lugar expedición</label>
            <p>{getCityName(repLegal?.Pws_Lugar_exp)}</p>
          </li>
          <li>
            <label>Fecha expedición</label>
            <p>{formatDate(repLegal?.Pws_Fec_expe)}</p>
          </li>
          
        </ul>

         <ul className="nopadding">
          
          <li>
            <label>Dirección</label>
            <p>{repLegal?.Pws_Direccion_res}</p>
          </li>
          <li>
            <label>Teléfono principal</label>
            <p>{repLegal?.Pws_Telefono1}</p>
          </li>
          <li>
            <label>Correo electrónico</label>
            <p>{repLegal?.Pws_Correo}</p>
          </li>
          <li>
            <label>Ciudad residencia</label>
            <p>{getCityName(repLegal?.Pws_Ciudad_res)}</p>
          </li>
         </ul>
      </div>
      <div className="sub-box redBox">
        <h3>Información financiera</h3>
        <ul className="nopadding">
          <li>
            <label>Activos</label>
            <p>{personaJuridica?.activo_jur}</p>
          </li>
          <li>
            <label>Pasivos</label>
            <p>{personaJuridica?.pas_jur}</p>
          </li>
          <li>
            <label>Ingresos</label>
            <p>{personaJuridica?.ingre_jur}</p>
          </li>
          <li>
            <label>Egresos</label>
            <p>{personaJuridica?.egre_jur}</p>
          </li>
        </ul>
      </div>
      <div className="sub-box redBox">
        <h3>Información tributaria</h3>
        <ul className="nopadding">
          <li>
            <label>Tipo de contribuyente</label>
            <p>{personaJuridica?.tip_contribu}</p>
          </li>
          <li>
            <label>Autoretenedor</label>
            <p>{personaJuridica?.auto_rete}</p>
          </li>
          <li>
            <label>Responsable IVA</label>
            <p>{personaJuridica?.ret_iva}</p>
          </li>
        </ul>
      </div>
       <button type="submit" id="botonSubmit" style={{ display: 'none' }}></button>
                                      <div className="submit">
                                         
                                              <>
                                                  {revisado ? (
                                                      <>
                                                          <button
                                                              type="button"
                                                              style={{ marginTop: '10px' }}
                                                              onClick={() => {
                                                                  setRevisado(false);
                                                                  changeDatoList(1);
                                                              }}>
                                                              Revisado
                                                          </button>
                                                      </>
                                                  ) : (
                                                      <>
                                                          {' '}
                                                          <GreenCheck />{' '}
                                                      </>
                                                  )}
                                              </>
                                        
                                      </div>
    </div>
  );
};